import type { RangeType } from '#types';

type NodeDateRangeQueryParameter = {
  $gte: string;
  $lte: string;
};

export const toNodeDateRangeQueryParameter = (range?: RangeType): NodeDateRangeQueryParameter | undefined => {
  if (range === undefined) {
    return undefined;
  }

  return {
    $gte: range[0].toISOString(),
    $lte: range[1].toISOString(),
  };
};
